import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "./Layout";
import { getCategories } from "../services/api";

export default function Categories() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    getCategories()
      .then((data) => {
        setCategories(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <Layout>
        <div className="text-center py-20 text-gray-300 text-xl">
          Loading categories...
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <section className="text-center px-6 md:px-16 py-12 mx-auto">
        <h2 className="text-5xl font-serif text-light_primary mb-4">
          Explore Our Categories
        </h2>
        <p className="text-lg text-black">
          Curated collections of Luxury gifts, Antique and Vintage items, and
          timeless decor. Discover pieces that bring elegance and heritage into
          your home.
        </p>
      </section>

      <section className="px-6 md:px-16 py-12 mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
          {categories.map((cat) => (
            <div
              key={cat._id}
              className="group relative rounded-xl overflow-hidden shadow-lg bg-light_cream"
            >
              <img
                src={cat.image}
                alt={cat.name}
                className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-black bg-opacity-40 group-hover:bg-opacity-60 transition duration-300 flex flex-col justify-end p-6">
                <h3 className="text-2xl font-serif text-white">{cat.name}</h3>
                <p className="text-sm text-gray-200 mt-2">{cat.description}</p>
                <button
                  onClick={() => navigate(`/products/${cat.slug}`)}
                  className="mt-4 self-start bg-light_primary text-white px-4 py-2 rounded"
                >
                  View More
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>
    </Layout>
  );
}
